import { getDataType } from '@/utils/common.js';

export class RequestCancel {
  pendingMap = new Map();

  getPendingKey(config) {
    if (Object.hasOwnProperty.call(config, 'code') && config.code === 'ERR_CANCELED') {
      return config.message;
    }
    let params = getDataType(config.params) === 'object' ? JSON.stringify(config.params) : config.params;
    let data = getDataType(config.data) === 'object' ? JSON.stringify(config.data) : config.data;
    return [config.url, config.method, params, data].join('&');
  }

  addPending(config, axios) {
    this.removePending(config, true);

    const pendingKey = this.getPendingKey(config);
    config.cancelToken =
      config.cancelToken ||
      new axios.CancelToken((cancel) => {
        if (!this.pendingMap.has(pendingKey)) {
          this.pendingMap.set(pendingKey, cancel);
        }
      });
  }

  removePending(config, needCancel = false) {
    const pendingKey = this.getPendingKey(config);
    if (this.pendingMap.has(pendingKey)) {
      if (needCancel) {
        const cancelToken = this.pendingMap.get(pendingKey);
        cancelToken(pendingKey);
      }

      this.pendingMap.delete(pendingKey);
    }
  }

  clearPending() {
    this.pendingMap = new Map();
  }
}
